
import React, { useEffect, createContext } from 'react';
import FeedbackModal from '../feedback/FeedbackModal';
import { useDisclosure } from '@chakra-ui/react';
import FeedbackPromptModal from '../feedback/FeedbackPromptModal';

export const feedbackContext = createContext();

const FEEDBACK_PROMPT_DELAY = 2 * 60 * 1000; // 2 mins in ms
const FEEDBACK_PROMPT_REMINDER_DELAY = 24 * 60 * 60 * 1000; // 1 day in ms

const FeedbackProvider = (props) => {
    const { isOpen: feedbackModalIsOpen, onOpen: feedbackModalOnOpen, onClose: feedbackModalOnClose } = useDisclosure();
    const { isOpen: feedbackPromptIsOpen, onOpen: feedbackPromptOnOpen, onClose: feedbackPromptOnClose } = useDisclosure();

    const checkFeedbackTimestamp = () => {
        const promptForFeedbackAt = localStorage.getItem('promptForFeedbackAt');
        const now = Date.now();

        if (promptForFeedbackAt && now >= parseInt(promptForFeedbackAt, 10)) {
            feedbackPromptOnOpen();
            // once it's been triggered, set the next prompt to Infinity
            localStorage.setItem('promptForFeedbackAt', Infinity);
        }
    };

    useEffect(() => {
        // first check if a promptAt time has been set
        const promptForFeedbackAt = localStorage.getItem('promptForFeedbackAt');
        if (!promptForFeedbackAt) {
            // set the initial promptAt timestamp to now plus a delay
            const feedbackPromptTimestamp = Date.now() + FEEDBACK_PROMPT_DELAY;
            localStorage.setItem('promptForFeedbackAt', feedbackPromptTimestamp);
        }

        // set up an interval that checks every 2 minutes if the modal should be shown
        const checkInterval = 5 * 1000; // 5 seconds
        const interval = setInterval(checkFeedbackTimestamp, checkInterval);

        return () => clearInterval(interval);
    }, []);

    // if the user closes the modal without providing feedback or clicking "Don't ask me again", 
    // prompt them again after a set delay
    const promptUserLater = () => {
        const feedbackPromptTimestamp = Date.now() + FEEDBACK_PROMPT_REMINDER_DELAY;
        localStorage.setItem('promptForFeedbackAt', feedbackPromptTimestamp);
    };

    return (
        <feedbackContext.Provider value={[feedbackModalIsOpen, feedbackModalOnOpen]}>
            {props.children}
            <FeedbackModal isOpen={feedbackModalIsOpen} onOpen={feedbackModalOnOpen} onClose={feedbackModalOnClose} />
            <FeedbackPromptModal isOpen={feedbackPromptIsOpen} onClose={feedbackPromptOnClose} feedbackModalOnOpen={feedbackModalOnOpen} promptUserLater={promptUserLater} />
        </feedbackContext.Provider>
    );
};

export default FeedbackProvider;